/* eslint-disable */
import './Meal.scss';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaHeart } from 'react-icons/fa';

// generate or load userId once per browser
function getUserId() {
  let id = localStorage.getItem("userId");
  if (!id) {
    id = Math.random().toString(36).substring(2, 12); // simple unique ID
    localStorage.setItem("userId", id);
  }
  return id;
}

function Meal({ CatagoryId, meal }) {
  const { id, src, name, discription, price } = meal;
  const userId = getUserId();

  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`https://deluxe-menu-backend.onrender.com/api/meals/${CatagoryId}/${id}/likes?userId=${encodeURIComponent(userId)}`)
      .then(res => res.json())
      .then(data => {
        setLikes(data.likes);
        setLiked(data.liked);
      });
  }, [CatagoryId, id, userId]);

const handleLike = () => {
  // Toggle UI immediately
  setLiked(prev => !prev);
  setLikes(prev => (liked ? prev - 1 : prev + 1));

  // Then call backend
  fetch(`https://deluxe-menu-backend.onrender.com/api/meals/${CatagoryId}/${id}/like`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId })
  })
    .then(res => res.json())
    .then(data => {
      // Sync with backend just in case
      setLikes(data.likes);
      setLiked(data.liked);
    })
    .catch(err => {
      console.error(err);
      // Rollback UI if backend fails
      setLiked(prev => !prev);
      setLikes(prev => (liked ? prev + 1 : prev - 1));
    });
};


  return (
    <div className="meal-container">
      <div className="image-container">
                <img
          src={src}
          alt={name}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          className={`meal-image ${loaded ? "loaded" : "loading"}`}
        />
        <button
          type="button"
          className={`like-button ${liked ? 'liked' : ''}`}
          onClick={handleLike}
        >
          <FaHeart /> {likes}
        </button>
      </div>
      <div className="name-container">
        <span>{name}</span>
      </div>
      <div className="discription-container">
        <p>{discription}</p>
      </div>
      {price && (
        <div className="price">
          <span>₪{price}</span>
        </div>
)}

    </div>
  );
}

Meal.propTypes = {
  meal: PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
    id: PropTypes.number,
    discription: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
  CatagoryId: PropTypes.number.isRequired,
};

export default Meal;
